var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.8 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Telephone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.1 18.8h11.4v-9h-11.4v9zm1-7.9h9.3v6.9h-9.3v-6.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27.7,
    width: 2.7,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30.4,
    width: 2.7,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 27.7,
    width: 2.7,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 30.4,
    width: 2.7,
    height: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 27.7,
    width: 2.7,
    height: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 30.4,
    width: 2.7,
    height: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 33.2,
    width: 2.7,
    height: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 33.2,
    width: 2.7,
    height: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 33.2,
    width: 2.7,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 23c0-1.4-1.8-2.5-4.2-2.5s-4.2 1.1-4.2 2.5 1.8 2.5 4.2 2.5 4.2-1.1 4.2-2.5zm-7.4 0c0-0.7 1.3-1.5 3.1-1.5s3.1 0.8 3.1 1.5-1.3 1.5-3.1 1.5-3.1-0.8-3.1-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.8 20.5h-2.1v-20.5h-5.2v4.9h-8c-2.7-0.1-4.9 2.1-4.9 4.8v10.8h-1.5c-2.8 0-5.1 2.3-5.1 5.1v17.4c0 2.8 2.3 5 5.1 5h21.7c2.8 0 5.1-2.3 5.1-5.1v-17.5c-0.1-2.7-2.3-4.9-5.1-4.9zm-19-10.8c0-2 1.6-3.6 3.6-3.6h9.2v-4.9h2.7v36.9h-15.5v-28.4zm-6.7 15.8c0-2.2 1.8-4 4-4h1.5v16.8c0 0.5 0.4 1 1 1h16.1c0.5 0 1-0.4 1-1v-16.8h2.1c2.2 0 4 1.8 4 4v12.5c0 2.2-1.8 4-4 4h-21.7c-2.2 0-4-1.8-4-4v-12.5zm29.7 17.5c0 2.2-1.8 4-4 4h-21.7c-2.2 0-4-1.8-4-4v-1.8c0.9 1.2 2.4 2 4 2h21.7c1.6 0 3.1-0.8 4-2v1.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.ca6395c78ec637b3f8a4761ac97671c5.svg";
export { ForwardRef as ReactComponent };